// FAR-82: the working-days screen. Pure, so its rules -- labels, what counts
// as assumed, what a save sends, what's valid -- are tested without a browser.

const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December']

// "2026-11" -> "November 2026"
export function monthLabel(iso) {
  const [y, m] = String(iso || '').split('-')
  const name = MONTH_NAMES[Number(m) - 1]
  return name ? `${name} ${y}` : String(iso || '')
}

// Calendar days in a month: the most working days it can have.
export function daysInMonth(iso) {
  const [y, m] = String(iso || '').split('-').map(Number)
  if (!y || !m || m < 1 || m > 12) return 0
  return new Date(Date.UTC(y, m, 0)).getUTCDate()
}

// What was typed, as a working-day count -- or an error message.
export function parseWorkingDays(text, iso) {
  const s = String(text ?? '').trim()
  if (!/^\d+$/.test(s)) return { error: 'Enter a whole number of days' }
  const n = Number(s)
  const max = daysInMonth(iso)
  if (n > max) return { error: `${monthLabel(iso)} has ${max} days` }
  return { value: n }
}

// The PUT body for one month.
export function saveBody(plant, workingDays, note) {
  return { plant, workingDays, note: String(note || '').trim() }
}

// The header summary: "3 of 12 months set · 9 still assumed (22 days)".
export function summary(months, defaultDays) {
  const list = months || []
  const assumed = list.filter((m) => m.assumed).length
  const set = list.length - assumed
  if (list.length === 0) return 'No months to plan yet'
  if (assumed === 0) return `All ${list.length} months set`
  return `${set} of ${list.length} months set · ${assumed} still assumed (${defaultDays} days)`
}

// "Weekdays 21 · 2 off" -- how the value compares with a plain Mon–Fri count.
export function vsWeekdays(month) {
  if (month.assumed) return `Weekdays ${month.weekdays}`
  const diff = month.weekdays - month.workingDays
  if (diff === 0) return `Weekdays ${month.weekdays}`
  return diff > 0
    ? `Weekdays ${month.weekdays} · ${diff} off`
    : `Weekdays ${month.weekdays} · ${-diff} extra`
}

// Planners and Admins can edit (FAR-82, Tyler 2026-10-20). The session's
// roles are the Cognito claim as stored by services/auth.js: a string, comma-
// separated ("admin", "Planner,Admin"). Matched per role and in any case, as
// the API's HasRole does -- so "SuperPlanner" isn't "Planner". The API checks
// too; this only decides whether to show the editor.
export function canEditCalendar(roles) {
  const list = Array.isArray(roles) ? roles : String(roles || '').split(',')
  return list.some((r) => ['planner', 'admin'].includes(String(r).trim().toLowerCase()))
}
